import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { ReportesNormativosRoutingModule } from './reportes-normativos-routing.module';
import { ReportesComponent } from './reportes/reportes.component';
import { SharedModule } from '../../shared/shared.module';


@NgModule({
  declarations: [
    ReportesComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    ReportesNormativosRoutingModule
  ]
})
export class ReportesNormativosModule { }
